import Settings from '../Icons/Settings'
import IconButton from './IconButton'

const ButtonSettings = ({
    showLabel = false,
    title = null,
    onClick = null,
    dim = false,
    size = 1,
    overrides = null,
}) => {
    const label = showLabel && title?.length > 0 ? <span>{title}</span> : null

    return (
        <IconButton
            title={title}
            onClick={onClick}
            showLabel={showLabel}
            css={overrides}
            data-testid="IconButton__PMSettings"
            dim={dim}
        >
            <Settings size={size} filled />
            {label}
        </IconButton>
    )
}

export default ButtonSettings
